import axios from 'axios';

import { getAPIUrl } from './baseAPI';

export type AICodingJobType = 'CATEGORY_GENERATION' | 'CLASSIFICATION';

export type AICodingJobStatus =
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'COMPLETE'
  | 'FAILED';

export interface AICodingJob {
  id: number;
  createdAt: string;
  jobType: AICodingJobType;
  questionId: number;
  status: AICodingJobStatus;
  waveId: number | null;
  updatedAt: string;
}

export const FETCH_AI_CODING_JOBS = ({
  questionId,
}: {
  questionId: number;
}) => ({
  path: `/aiCodingJobs/question/${questionId}`,
  version: 'v2' as const,
});

export async function fetchAICodingJobs({
  questionId,
}: {
  questionId: number;
}): Promise<AICodingJob[]> {
  const response = await axios.get<AICodingJob[]>(
    getAPIUrl(FETCH_AI_CODING_JOBS({ questionId })),
  );
  return response.data;
}
